import type { ReactNode } from "react";
import type { JobStatus, ArchiveJobReason } from "../../../features/device-archive/jobs";

const STATUS_STYLE: Record<JobStatus, { light: string; dark: string }> = {
  running: {
    light: "bg-amber-50 text-amber-700 ring-1 ring-amber-200",
    dark: "bg-amber-500/15 text-amber-300 ring-1 ring-amber-500/30",
  },
  done: {
    light: "bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200",
    dark: "bg-emerald-500/15 text-emerald-300 ring-1 ring-emerald-500/30",
  },
  failed: {
    light: "bg-red-50 text-red-700 ring-1 ring-red-200",
    dark: "bg-red-500/15 text-red-300 ring-1 ring-red-500/30",
  },
  deleted: {
    light: "bg-gray-100 text-gray-600 ring-1 ring-gray-200",
    dark: "bg-white/10 text-gray-300 ring-1 ring-white/15",
  },
};

export function StatusBadge({
  status,
  label,
  isDarkMode,
}: {
  status: JobStatus;
  label: string;
  isDarkMode: boolean;
}): ReactNode {
  const style = STATUS_STYLE[status] ?? STATUS_STYLE.deleted;
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${
        isDarkMode ? style.dark : style.light
      }`}
    >
      {label}
    </span>
  );
}

const REASON_STYLE: Record<ArchiveJobReason, { light: string; dark: string }> = {
  delete: {
    light: "bg-red-50 text-red-700 ring-1 ring-red-200",
    dark: "bg-red-500/15 text-red-300 ring-1 ring-red-500/30",
  },
  suspend: {
    light: "bg-orange-50 text-orange-700 ring-1 ring-orange-200",
    dark: "bg-orange-500/15 text-orange-300 ring-1 ring-orange-500/30",
  },
  transfer: {
    light: "bg-sky-50 text-sky-700 ring-1 ring-sky-200",
    dark: "bg-sky-500/15 text-sky-300 ring-1 ring-sky-500/30",
  },
};

export function ReasonBadge({
  reason,
  label,
  isDarkMode,
}: {
  reason: ArchiveJobReason;
  label: string;
  isDarkMode: boolean;
}): ReactNode {
  const style = REASON_STYLE[reason] ?? REASON_STYLE.suspend;
  const cls = isDarkMode ? style.dark : style.light;
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${cls}`}
    >
      {label}
    </span>
  );
}
